module.exports = __webpack_public_path__ + "img/otrosIngresos48.5e8df2f9.png";